import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { rate } from './thunks';
import { RatingState } from './types';

export const name = 'rating';

const initialState: RatingState = {
  rateStatus: 'idle',
};

export const rateAsync = createAsyncThunk(name + '/rate', rate);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearRateStatus: (state) => {
      state.rateStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rateAsync.pending, (state) => {
        state.rateStatus = 'loading';
      })
      .addCase(rateAsync.fulfilled, (state) => {
        state.rateStatus = 'success';
      })
      .addCase(rateAsync.rejected, (state) => {
        state.rateStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
